import routes from "@/routes";

import { Table, Button } from "antd";

import CustomLink from "@/components/ui/CustomLink";

import TrashIcon from "@/icons/TrashIcon";

// Таблица связанных объектов (используется в шаблоне задачи)
// Содержит список с возможностью сортировки
// Тут можно настроить колонки
const AttachedObjectsTable = ({ data, isAdmins, loading, onDeleteItem }) => {
  const columns = [
    {
      title: "Тип",
      dataIndex: "definition",
      key: "definition",
      ellipsis: {
        showTitle: false,
      },
      sorter: {
        compare: (a, b) => a.definition.name.localeCompare(b.definition.name),
      },
      render: (_, { definition }) => (
        <CustomLink
          to={
            isAdmins
              ? routes.administration.objectList(definition.uuid)
              : routes.objectList(definition.uuid)
          }
          color="#303030"
        >
          {definition.name}
        </CustomLink>
      ),
    },

    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      ellipsis: {
        showTitle: false,
      },
      sorter: {
        compare: (a, b) => a.object.name.localeCompare(b.object.name),
      },
      render: (_, { object, definition }) => {
        const isCanViewFalse = object?.canView === false;

        return isCanViewFalse ? (
          <div>{object.name}</div>
        ) : (
          <CustomLink
            to={
              isAdmins
                ? routes.administration.objectDetail(
                    definition.uuid,
                    object.uuid,
                  )
                : routes.objectDetail(definition.uuid, object.uuid)
            }
            color="#303030"
          >
            {object.name}
          </CustomLink>
        );
      },
    },

    {
      title: "",
      width: 50,
      fixed: "right",
      key: "actions",
      render: (_, item) => (
        <Button
          type="link"
          icon={<TrashIcon />}
          onClick={() => onDeleteItem(item)}
        ></Button>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="uuid"
        loading={loading}
        pagination={false}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={{
          x: "100%",
        }}
      />
    </>
  );
};

export default AttachedObjectsTable;
